module.exports = __webpack_public_path__ + "img/11_military.6526c0c3.png";